import { useState } from 'react'

import { localStorageService } from '~/@common/services/storage.service'

export const useCasBackConfirmSkip = () => {
  const [skip, setSkipState] = useState(() => localStorageService.cas.skipBackConfirm)

  const setSkip = (next: boolean) => {
    localStorageService.update({ cas: { skipBackConfirm: next } })
    setSkipState(next)
  }

  return { skip, setSkip }
}
